var _g, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25833_193987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 0.599609H17.752L27.4004 10.248V28.7998C27.4004 30.2357 26.2357 31.4004 24.7998 31.4004H7.2002C5.76426 31.4004 4.59961 30.2357 4.59961 28.7998V3.2002C4.59961 1.76426 5.76425 0.599609 7.2002 0.599609Z",
    fill: "white",
    stroke: "#C8D2E1",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 0.799805V7.9998C17.6 9.32529 18.6745 10.3998 20 10.3998H27.2",
    stroke: "#C8D2E1",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14.2002,
    width: 22,
    height: 14.2,
    rx: 1.6,
    fill: "#D92D20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91588 24.7998V18.2543H5.49827C5.99472 18.2543 6.41766 18.3492 6.76709 18.5388C7.11652 18.7263 7.38286 18.9873 7.5661 19.3218C7.75147 19.6542 7.84415 20.0377 7.84415 20.4724C7.84415 20.907 7.7504 21.2906 7.5629 21.623C7.3754 21.9553 7.10374 22.2142 6.74792 22.3996C6.39422 22.585 5.96596 22.6776 5.46311 22.6776H3.81716V21.5686H5.23939C5.50573 21.5686 5.72519 21.5228 5.89777 21.4312C6.07249 21.3374 6.20246 21.2085 6.28769 21.0445C6.37505 20.8783 6.41873 20.6876 6.41873 20.4724C6.41873 20.2551 6.37505 20.0654 6.28769 19.9035C6.20246 19.7394 6.07249 19.6127 5.89777 19.5232C5.72306 19.4316 5.50147 19.3857 5.233 19.3857H4.29976V24.7998H2.91588ZM8.56303 24.7998V18.2543H11.1454C11.6419 18.2543 12.0648 18.3492 12.4142 18.5388C12.7637 18.7263 13.03 18.9873 13.2132 19.3218C13.3986 19.6542 13.4913 20.0377 13.4913 20.4724C13.4913 20.907 13.3976 21.2906 13.2101 21.623C13.0226 21.9553 12.7509 22.2142 12.3951 22.3996C12.0414 22.585 11.6131 22.6776 11.1103 22.6776H9.46431V21.5686H10.8865C11.1529 21.5686 11.3723 21.5228 11.5449 21.4312C11.7196 21.3374 11.8496 21.2085 11.9348 21.0445C12.0222 20.8783 12.0659 20.6876 12.0659 20.4724C12.0659 20.2551 12.0222 20.0654 11.9348 19.9035C11.8496 19.7394 11.7196 19.6127 11.5449 19.5232C11.3702 19.4316 11.1486 19.3857 10.8801 19.3857H9.94691V24.7998H8.56303ZM13.9609 19.3953V18.2543H19.3366V19.3953H17.3327V24.7998H15.9648V19.3953H13.9609Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25833_193987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white",
    transform: "translate(4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.c99aaa6fff75e0bfe5cb3c7ae2e0929f.svg";
export { ForwardRef as ReactComponent };